export default __webpack_public_path__ + "static/media/sun.b288121d.svg";